import VueRouter from 'vue-router'
import Vue from 'vue'
import routerHook from './routerHook.js'

Vue.use(VueRouter)
const routes = [{
  name: 'home',
  path: '/',
  component: () => import('@/views/home/home.vue')
}, {
  name: 'payend',
  path: '/payend',
  component: () => import('@/views/payend/payend.vue')
}, {
  name: 'wxclient_payorder',
  path: '/wxclient_payorder',
  component: () => import('@/views/wxclient_payorder/wxclient_payorder.vue')
}, {
  path: '*',
  redirect: '/'
}]

const _router = new VueRouter({
  routes,
  strict: process.env.NODE_ENV !== 'production',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

routerHook(_router)
export default _router
